import ProjectView from './ProjectView';

export default ProjectView;
